const heroFunctions = () => {
    let isPaused = false;

    $(document).on('click', '.js-video-control', function(e) {
        e.preventDefault();

        const heroVideo = document.getElementById('hero_section_video');

        if ( isPaused ) {
            heroVideo.play();
        } else {
            heroVideo.pause();
        }

        $(this).stop().toggleClass('paused');
        isPaused = !isPaused;
    });
};